import { useEffect, useRef, useState } from 'react'

export type RowAction = {
  key: string
  label: string
  danger?: boolean
  onClick: () => void
}

export default function RowActionsMenu({ actions }: { actions: RowAction[] }) {
  const [open, setOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!open) return
    const onDocClick = (e: MouseEvent) => {
      if (!rootRef.current) return
      if (!rootRef.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [open])

  return (
    <div className="relative" ref={rootRef}>
      <button
        type="button"
        aria-label="More actions"
        className="rounded border border-white/15 px-2 py-1 text-xs hover:bg-white/10"
        onClick={() => setOpen((v) => !v)}
      >
        ⋯
      </button>
      {open ? (
        <div className="absolute right-0 z-20 mt-1 w-44 rounded-lg border border-white/15 bg-zinc-950 p-1 shadow-lg">
          {actions.map((action) => (
            <button
              key={action.key}
              type="button"
              className={`flex w-full items-center rounded px-2 py-1.5 text-left text-xs hover:bg-white/10 ${action.danger ? 'text-red-200' : 'text-white/90'}`}
              onClick={() => {
                setOpen(false)
                action.onClick()
              }}
            >
              {action.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  )
}
